import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  ChangeDetectorRef,
  AfterViewChecked,
  AfterViewInit,
} from "@angular/core";
import { jsPDF } from "jspdf";
import { MatTableDataSource } from "@angular/material/table";
import { SelectionModel } from "@angular/cdk/collections";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { Observable } from "rxjs";
import { map, startWith, filter, first } from "rxjs/operators";
import { MatTableExporterModule } from "mat-table-exporter";
import { TranslateService } from "@ngx-translate/core";
import {
  MatSnackBar,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from "@angular/material/snack-bar";
import * as XLSX from "xlsx";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { TableUtil } from "./tableUtil";

import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { TraslateService } from "../traslate.service";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import {
  DateAdapter,
  ErrorStateMatcher,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from "@angular/material/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormGroupDirective,
  NgForm,
  Validators,
} from "@angular/forms";
import {
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
  MomentDateAdapter,
} from "@angular/material-moment-adapter";
import { MY_FORMATS } from "../vehicle/vehicle.component";
import { environment } from "src/environments/environment";
import { NgxSpinnerService } from "ngx-spinner";
import { ActivatedRoute, Router } from "@angular/router";

import { AuthenticationService, UserService } from "src/app/_services";

export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(
    control: FormControl | null,
    form: FormGroupDirective | NgForm | null
  ): boolean {
    const isSubmitted = form && form.submitted;
    return !!(
      control &&
      control.invalid &&
      (control.dirty || control.touched || isSubmitted)
    );
  }
}

/**
 * @title Table with selection
 */
@Component({
  selector: "app-driver",
  templateUrl: "./driver.component.html",
  styleUrls: ["./driver.component.scss"],
})
export class DriverComponent
  implements OnInit, AfterViewChecked, AfterViewInit
{
  repos: any;
  URL: RequestInfo;
  dataSource: MatTableDataSource<any>;

  displayedColumns: string[] = [
    "select",
    "id",
    "last_name",
    "first_name",
    "company",
    "gsm_number",
    "date_birth",
    "dallas",
    "action",
  ];
  displayedColumns2: string[] = [
    "id",
    "last_name",
    "first_name",
    "company",
    "gsm_number",
    "date_birth",
    "dallas",
  ];
  selection = new SelectionModel(true, []);
  filterSelectObj = [];
  dd: void;
  listItems: any = [];
  manualPage: number = 0;
  pageSize1: any;
  pageSize: any = 15;
  lengthpage: number = 100;
  pageNum: any;

  manualPage1: number;
  lengthTotal: any;
  public currentPage = 0;
  public totalSize = 0;
  pageSizeOptions = [15, 30, 100];
  public dateTime: Date;
  index2: any = 30;

  pageSizeOptions1: number[];
  gg: any;
  itemSelect: any = [];

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  @ViewChild("myDiv") myDiv: ElementRef<HTMLElement>;
  @ViewChild("htmlData") htmlData: ElementRef;
  @ViewChild("pdfTable", { static: false }) pdfTable: ElementRef;

  filterValues = {};
  json: any;
  Itemss: any;
  ddd: boolean;
  entry: any;
  lengthSelected: number;
  textSelected: string;
  inputEt: boolean;
  IconOn: boolean;
  IconOnn: boolean;
  IconOnItems: string;
  hidden: boolean;
  ggg: number;
  gogo: void;
  gogoo: any = 0;
  tt: string;
  name: any;
  company: any;
  dallas: any;
  gsm_number: any;
  date_birth: any;
  driverSpinner: boolean = false;
  driverSpinnerList: boolean = false;

  constructor(
    private _snackBar: MatSnackBar,
    private userService: UserService,
    public dialog: MatDialog,
    public traslateService: TraslateService,
    private http: HttpClient,
    private spinnerdriver: NgxSpinnerService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private cdRef: ChangeDetectorRef,
    private elementRef: ElementRef
  ) {
    this.index2 = 15;
    // Object to create Filter for
  }

  ngAfterViewChecked(): void {
    this.cdRef.detectChanges();
  }

  async refrech() {
    this.URL =
      "https://api.github.com/search/repositories?q=created:>2020-08-21&sort=stars&order=desc&page=5";

    const response = await fetch(this.URL);

    this.json = await response.json();
    //console.log('dfsdfsdf'+this.json.items.length);
    this.lengthTotal = this.json.items.length;

    this.repos = await this.json.items;

    //console.log(this.repos)
  }

  exportTable() {
    Swal.fire({
      title: "Souhaitez-vous exporter la table ?",
      showCancelButton: true,
      confirmButtonText: "Exporter Fichier !",
      cancelButtonText: "Annuler",
      confirmButtonColor: "#262756",
      cancelButtonColor: "#e05a61",
    }).then((result) => {
      if (result.value) {
        Swal.fire("Le fichier est exporté.");

        TableUtil.exportToPdf("ExampleTable", "tbl");
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire("Annullé", "Fichier non exporté !!");
      }
    });
  }

  async getrepos() {
    this.URL =
      "https://api.github.com/search/repositories?q=created:>2020-08-21&sort=stars&order=desc&page=5";

    const response = await fetch(this.URL);

    this.json = await response.json();

    this.lengthTotal = this.json.items.length;
    this.Itemss = this.json.items;

    this.repos = await this.json.items;

    //console.log(this.repos)
    this.dataSource = new MatTableDataSource(this.repos);
  }

  getgogo() {
    localStorage.setItem("num1", this.selection.selected.length.toString());
    this.gogoo = localStorage.getItem("num1");
    console.log(this.gogoo);
  }

  getDriver() {
    const headerDict = {
      "Content-Type": "application/json",
      Accept: "application/json",
      "Access-Control-Allow-Headers": "Content-Type",
    };

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };
    this.driverSpinnerList = false;
    this.driverSpinner = true;
    this.spinnerdriver.show();
    this.http
      .get(environment.apiUrl + "/drivers", requestOptions)
      .subscribe((response) => {
        this.resetFilters();
        //console.log(response)
        var list: any = response;

        this.lengthTotal = list.drivers.length;
        this.Itemss = list.drivers;

        this.repos = list.drivers;

        //console.log(this.repos)
        this.dataSource = new MatTableDataSource(this.repos);
        this.dataSource.paginator = this.paginator;

        this.dataSource.sort = this.sort;

        this.getRemoteData();

        // Overrride default filter behaviour of Material Datatable
        this.dataSource.filterPredicate = this.createFilter();

        this.spinnerdriver.hide();
        this.driverSpinner = false;
        this._snackBar.open(
          "les données des conducteurs actualiser ",
          "Fermer",
          {
            duration: 2500,
          }
        );
      });
  }

  getItemsCompanies() {
    console.log("getItemsCompanies");
    console.log(this.searchbycompnyId);

    if (this.roleuser == "User") {
      this.getDriverListUser(15, 1);
    } else {
      this.getDriverList(15, 1);
    }

    console.log("test ");
  }

  resetdatadriverlistl() {
    this.searchbyname = "";
    this.searchbycompnyId = "";
    this.searchbygsmnumber = "";
    this.searchbydalass = "";
    this.getDriverList(15, 1);
  }

  applyFilterer(evnt) {
    if (this.roleuser == "User") {
      this.getDriverListUser(15, 1);
    } else {
      this.getDriverList(15, 1);
    }
  }

  resetdatavihclcompny() {
    if (this.roleuser == "User") {
      this.searchbycompnid = "";
      this.getDriverListUser(15, 1);
    } else {
      this.searchbycompnid = "";
      this.getDriverList(15, 1);
    }
  }

  searchbyname: any = "";
  searchbycompnyId: any = "";
  searchbygsmnumber: any = "";
  searchbydalass: any = "";
  searchbycompnid: any = "";
  Listcompanies: any = [];

  async getCompny() {
    const headerDict = {
      "Content-Type": "application/json",
      Accept: "application/json",
      "Access-Control-Allow-Headers": "Content-Type",
    };

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };
    this.driverSpinnerList = true;
    this.driverSpinner = true;
    this.spinnerdriver.show();
    await this.http
      .get(environment.apiUrl + "/companies", requestOptions)
      .subscribe((response: any) => {
        console.log("/ccompaniescompaniescompanies'");
        console.log(response);
        this.Listcompanies = response.companies;
      });
  }

  async getDriverListUser(currentSize, offset) {
    const headerDict = {
      "Content-Type": "application/json",
      Accept: "application/json",
      "Access-Control-Allow-Headers": "Content-Type",
    };

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };
    this.driverSpinnerList = true;
    this.driverSpinner = true;
    this.spinnerdriver.show();
    await this.http
      .get(
        environment.apiUrl +
          "/companies/" +
          this.userinfo.company_id +
          "/drivers" +
          "?page=" +
          offset +
          "&gsm_number=" +
          this.searchbygsmnumber +
          "&dallas=" +
          this.searchbydalass +
          "&name=" +
          this.searchbyname,
        requestOptions
      )
      .subscribe((response: any) => {
        console.log("/companies/'+this.userinfo.company_id+'/drivers'");
        console.log(response);
        var list: any = response.drivers.data;
        this.lengthTotal = response.drivers.total;
        // this.Itemss =list.drivers.data
        if (currentSize == 0) {
          list.length = 15;
        } else {
          list.length = currentSize;
        }

        this.repos = response.drivers.data;
        this.repos.push(...list);
        this.repos.length = response.drivers.total;
        console.log(" this.repos.length =response.drivers.total ");
        console.log(this.repos);

        //console.log(this.repos)
        this.dataSource = new MatTableDataSource(this.repos);
        this.dataSource._updateChangeSubscription();
        this.dataSource.paginator = this.paginator;

        this.dataSource.sort = this.sort;
        this.driverSpinnerList = false;
        this.driverSpinner = false;

        this.getRemoteData();

        // Overrride default filter behaviour of Material Datatable
        this.dataSource.filterPredicate = this.createFilter();
        this.spinnerdriver.hide();
        this.driverSpinnerList = false;
        this.driverSpinner = false;
      });
  }

  pageChanged(event) {
    console.log(" pageChanged(event)  pageChanged(event) ");
    console.log(event);
    let pageIndex = event.pageIndex;
    let pageSize = event.pageSize;

    let previousIndex = event.previousPageIndex;

    let previousSize = pageSize * pageIndex;
    console.log("pageSize");
    console.log(pageSize);

    console.log("pageIndex");
    console.log(pageIndex);

    if (this.roleuser == "User") {
      this.getDriverListUser(previousSize, (pageIndex + 1).toString());
    } else {
      this.getDriverList(previousSize, (pageIndex + 1).toString());
    }
  }

  getDriverList(currentSize, offset) {
    const headerDict = {
      "Content-Type": "application/json",
      Accept: "application/json",
      "Access-Control-Allow-Headers": "Content-Type",
    };

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };
    // this.spinnerdriver.show()
    this.http
      .get(
        environment.apiUrl +
          "/drivers" +
          "?page=" +
          offset +
          "&gsm_number=" +
          this.searchbygsmnumber +
          "&company_id=" +
          this.searchbycompnyId +
          "&dallas=" +
          this.searchbydalass +
          "&name=" +
          this.searchbyname +
          "&company_id=" +
          this.searchbycompnid,
        requestOptions
      )
      .subscribe((response: any) => {
        var list: any = response.drivers.data;
        this.lengthTotal = response.drivers.total;
        if (currentSize == 0) {
          list.length = 15;
        } else {
          list.length = currentSize;
        }
        this.repos = response.drivers.data;
        this.repos.push(...list);
        this.repos.length = response.drivers.total;
        this.dataSource = new MatTableDataSource(this.repos);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.getRemoteData();

        // Overrride default filter behaviour of Material Datatable
        this.dataSource.filterPredicate = this.createFilter();
        this.spinnerdriver.hide();
      });
  }

  roleuser: any = null;
  userinfo: any = null;

  async ngOnInit() {
    this.getCompny();
    this.activatedRoute.data.subscribe((data) => {
      console.log(
        " this.activatedRoute.data.subscribe(data => { this.activatedRoute.data.subscribe(data => {"
      );
      this.roleuser = data.roles[0];
      console.log(data.roles[0]);

      // User
    });

    if (this.roleuser == "User") {
      this.userService
        .getById()
        .pipe(first())
        .subscribe((user) => {
          console.log(
            " this.userService.getById().pipe(first()).subscribe(user => { "
          );
          console.log(user);
          console.log(user[0].id);
          this.userinfo = user[0];
          //   this.loading = false;
          // //  this.userFromApi = user;

          //   //console.log(user)

          //   //console.log(user.status)
          //   if (user.status== "Token is Expired") {
          //    this.logout()
          //   }
          this.getDriverListUser(15, "");
        });

      this.filterSelectObj = [
        {
          name: "GSM",
          columnProp: "gsm_number",
          options: [],
        },
        {
          name: "clé Dallas",
          columnProp: "dallas",
          options: [],
        },
      ];
    } else {
      this.getDriverList(15, "");
      this.filterSelectObj = [
        {
          name: "GSM",
          columnProp: "gsm_number",
          options: [],
        },
        {
          name: "clé Dallas",
          columnProp: "dallas",
          options: [],
        },
        {
          name: "compagnie",
          columnProp: "company",
          options: [],
        },
      ];
    }
  }
  @ViewChild("tasssaks") tasssaks: ElementRef;
  ngAfterViewInit() {
    //  this.updateManualPage2(this.index2)
    this.tasssaks.nativeElement.click();
  }

  // ngAfterViewInit() {
  //   // this.elementRef.nativeElement.getElementById('#tasssaks')
  //   //                               .addEventListener('tasssaks', this.onClick.bind(this));

  //   // this.elementRef.nativeElement.querySelectorAll('.tasssaks').forEach( function ( item ) {

  //   //   item.addEventListener('click', function(event) {
  //   //           console.log("item-clicked");

  //   //    });
  //   // });

  // }

  onClick(event) {
    console.log("event event event");
    console.log(event);
  }
  collection: any = [];

  public updateManualPage2(index2) {
    this.collection = [];

    //console.log(this.pageSizeOptions1)
    this.paginator.pageSize = index2;

    this.paginator.page.next({
      pageIndex: this.paginator.pageIndex,
      pageSize: index2,
      length: this.paginator.length,
    });
    //console.log('jjjj')

    this.lengthpage = parseInt("" + (this.paginator.length + 1) / index2);

    //console.log(this.lengthpage)

    //Create dummy data
    for (var i = 0; i < this.lengthpage; i++) {
      this.collection.push(i + 1);
    }

    //console.log(this.collection)
  }

  stateCtrl: any = "";

  filteredData;

  applyFilter(evt: string) {
    console.log("evnt ");
    console.log(evt);

    evt = evt + "";
    if (!evt) this.filteredData = this.Listcompanies;
    else {
      /** uses both id and text fields for extensive filtering (case insensitive) . can be tailored for custom needs */
      this.filteredData = this.Listcompanies.filter(
        (item) =>
          item.id + "" === evt ||
          item.name.toLocaleLowerCase().indexOf(evt.toLocaleLowerCase()) >= 0
      );
    }
  }

  valueMapper = (key) => {
    let selection = this.Listcompanies.find((e) => {
      return e.id == key;
    });
    if (selection) {
      return selection.name;
    }
  };

  getOptions(filter) {
    return filter.options;
  }

  onChangeEvent(filter, $event) {
    if ($event.target.value != "") {
      filter.options = this.getFilterObject(
        this.repos,
        filter.columnProp
      ).filter((option) => {
        if (option !== null)
          return option.toLowerCase().includes($event.target.value);
      });
    } else {
      this.filterValues[filter.columnProp] = "";
      this.dataSource.filter = JSON.stringify(this.filterValues);
    }
  }

  public updateManualPage(index): void {
    //console.log(index)
    this.pageNum = index;
    this.manualPage = index;
    this.paginator.pageIndex = index;

    this.paginator.page.next({
      pageIndex: this.paginator.pageIndex,
      pageSize: this.paginator.pageSize,
      length: this.paginator.length,
    });
  }

  toggleClass = false;

  async getItemsbyClick(row) {
    if (this.listItems.length == 0) {
      this.listItems.push(row);
    }
    // console.log("listItems listItems ");
    // console.log(this.listItems);
    // console.log(row);

    this.lengthSelected = this.listItems.length;
    this.lengthSelected = this.listItems.length;
    this.lengthSelected = this.listItems.length;
    for (let entry of this.listItems) {
      this.entry = entry.id;
      this.name = entry.name;
      this.company = entry.company;
      this.dallas = entry.dallas;
      this.gsm_number = entry.gsm_number;
      this.date_birth = entry.date_birth;
    }

    for (let entry of this.listItems) {
      this.entry = entry.id;
    }

    const { value: formValues } = await Swal.fire({
      border: " 1px solid #262853",
      width: 900,
      opacity: 1,
      background: "rgba(238,238,238,0)",
      showConfirmButton: false,
      // closeOnClickOutside: true ,
      // allowOutsideClick: false,
      // cancelButtonText: 'X',
      // cancelButtonClass:"swadzddztions",
      allowOutsideClick: () => {
        this.arr = [];
        this.listItems = [];
        this.selection.clear();
        return true;
      },
      // cancelButtonText:
      // '<i  style="color:red" class="fa fa-thumbs-down"></i>',
      showCancelButton: false,
      // +'<button class="tasssaks" #tasssaks >X </button>'+
      html:
        '<div style="background: rgba(255, 255, 255, 0.8);border-radius: 16px;box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);backdrop-filter: blur(13.7px); padding: 0px; margin: 0px;' +
        '-webkit-backdrop-filter: blur(8px);border: 1px solid rgba(255, 255, 255, 0.22);  border: 1px solid #262853;border-radius: 25px;">' +
        "<div>" +
        '<h1 class="pb-4" style="color :#262756;margin-right: 50%;margin-top: 5%;" > <strong> Détails du conducteur </strong> <h1>' +
        "</div>" +
        '<table class="swal" style="color :#262756;margin-left: 15%; text-align: left; margin-bottom: 10%;">' +
        ' <tr style="height: 24px !important;" ><td><h2 style="font-size: 15px;padding:0px; margin:0px;">Nom : </h2></td><td><h3 style="font-size: 15px; padding:0px; margin:0px;"> ' +
        (this.name != null ? this.name : "---") +
        "</h3></td></tr>" +
        ' <tr style="height: 14px !important;"><td><h2 style="font-size: 15px; padding:0px; margin:0px;">Compagnie : </h2></td><td><h3 style="font-size: 15px; padding:0px; margin:0px;"> ' +
        this.company +
        "</h3></td></tr>" +
        ' <tr style="height: 4px !important;"><td><h2 style="font-size: 15px; padding:0px; margin:0px;">Numero Telephone : </h2></td><td><h3 style="font-size: 15px; padding:0px; margin:0px;"> ' +
        (this.gsm_number != null ? this.gsm_number : "---") +
        "</h3></td></tr>" +
        ' <tr style="height: 14px; padding:0px; margin:0px;"><td><h2 style="font-size: 15px;padding:0px; margin:0px;">Dallas : </h2></td><td><h3 style="font-size: 15px;padding:0px; margin:0px;"> ' +
        this.dallas +
        "</h3></td></tr>" +
        ' <tr style="height: 14px; padding:0px; margin:0px;"><td><h2 style="font-size: 15px;padding:0px; margin:0px;">Date naissance : </h2></td><td><h3 style="font-size: 15px;padding:0px; margin:0px;"> ' +
        (this.date_birth != null ? this.date_birth : "---") +
        "</h3></td></tr>" +
        "</table>" +
        "</div>",
    }).then((result) => {
      if (result.isConfirmed) {
        // console.log('isConfirmed isConfirmed');
      } else {
        // console.log('else else');
        this.arr = [];
        this.listItems = [];
        this.selection.clear();
      }
    });
  }

  // Get Uniqu values from columns to build filter
  getFilterObject(fullObj, key) {
    const uniqChk = [];
    fullObj.filter((obj) => {
      if (!uniqChk.includes(obj[key])) {
        uniqChk.push(obj[key]);
      }
      return obj;
    });
    return uniqChk;
  }

  // Get remote serve data using HTTP call
  getRemoteData() {
    this.filterSelectObj.filter((o) => {
      o.options = this.getFilterObject(this.repos, o.columnProp);
    });
  }

  filterChange(filter, event) {
    // this.filterValues[filter.columnProp] = event.value.trim().toLowerCase()
    this.filterValues[filter.columnProp] = filter.modelValue;
    this.dataSource.filter = JSON.stringify(this.filterValues);
  }

  value = "";

  filterChangeList(event) {
    //let filterValues = {}
    this.filterValues["last_name"] = event.target.value.trim().toLowerCase();

    this.dataSource.filter = JSON.stringify(this.filterValues);
  }

  filterChangeList2() {
    this.value = "";
    this.filterValues["full_name"] = this.value;

    this.dataSource.filter = JSON.stringify(this.filterValues);
  }

  // Custom filter method fot Angular Material Datatable
  createFilter() {
    let filterFunction = function (data: any, filter: string): boolean {
      let searchTerms = JSON.parse(filter);
      let isFilterSet = false;
      for (const col in searchTerms) {
        if (searchTerms[col].toString() !== "") {
          isFilterSet = true;
        } else {
          delete searchTerms[col];
        }
      }

      //console.log(searchTerms);

      let nameSearch = () => {
        let found = false;
        if (isFilterSet) {
          for (const col in searchTerms) {
            searchTerms[col]
              .trim()
              .toLowerCase()
              .split(" ")
              .forEach((word) => {
                if (data[col] != null) {
                  data[col].toString().toLowerCase() ===
                    searchTerms[col].trim().toLowerCase();
                }
                if (
                  data[col] != null &&
                  data[col].toString().toLowerCase() ===
                    searchTerms[col].trim().toLowerCase() &&
                  isFilterSet
                ) {
                  found = true;
                }
              });
          }
          return found;
        } else {
          return true;
        }
      };
      return nameSearch();
    };
    return filterFunction;
  }

  // Reset table filters
  resetFilters() {
    this.value = "";
    this.filterValues["full_name"] = this.value;

    this.dataSource.filter = JSON.stringify(this.filterValues);

    this.filterValues = {};
    this.filterSelectObj.forEach((value, key) => {
      value.modelValue = undefined;
    });
    this.dataSource.filter = "";

    const headerDict = {
      "Content-Type": "application/json",
      Accept: "application/json",
      "Access-Control-Allow-Headers": "Content-Type",
    };

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };
    this.driverSpinnerList = false;
    this.driverSpinner = true;
    this.spinnerdriver.show();
    this.http
      .get(environment.apiUrl + "/drivers", requestOptions)
      .subscribe((response) => {
        //console.log(response)
        var list: any = response;

        this.lengthTotal = list.drivers.length;
        this.Itemss = list.drivers;

        this.repos = list.drivers;

        //console.log(this.repos)
        this.dataSource = new MatTableDataSource(this.repos);
        this.dataSource.paginator = this.paginator;

        this.dataSource.sort = this.sort;

        // Overrride default filter behaviour of Material Datatable
        this.dataSource.filterPredicate = this.createFilter();

        this.spinnerdriver.hide();
        this.driverSpinner = false;
      });

    this._snackBar.open("les données de filtrage réinitialiser ", "Fermer", {
      duration: 2000,
    });
  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;

    const numRows = this.dataSource?.data?.length;

    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected()
      ? this.selection.clear()
      : this.dataSource.data.forEach((row) => this.selection.select(row));
  }

  /** The label for the checkbox on the passed row */

  checkboxLabel(row?: any): string {
    if (!row) {
      return `${this.isAllSelected() ? "select" : "deselect"} all`;
    }

    this.listItems = this.selection.selected;
    this.lengthSelected = this.listItems.length;

    return `${this.selection.isSelected(row) ? "deselect" : "select"} row ${
      row.id + 1
    }`;
  }

  arr: any = [];

  supprimerItems(operation, id: any, reseller_id: any) {
    if (operation == "oneItem") {
      this.selection.clear();
      this.listItems = [];
      this.arr = [];
      this.listItems.push({
        id: id,
        reseller_id: reseller_id,
      });
      console.log("list", this.listItems);
    }
    for (var i = 0; i < this.listItems.length; i++) {
      var obj = {}; // <---- Move declaration inside loop

      obj["id"] = this.listItems[i].id;

      this.arr.push(this.listItems[i].id);
    }

    Swal.fire({
      title: "Voulez-vous supprimer ce conducteur?",
      showCancelButton: true,
      allowOutsideClick: false,
      confirmButtonColor: "#262756",
      cancelButtonColor: "#e05a61",
      confirmButtonText: "Oui",
      cancelButtonText: "Annuler",
    }).then((result) => {
      if (result.isConfirmed) {
        this.spinnerdriver.show();
        this.http
          .delete(environment.apiUrl + "/drivers/" + JSON.stringify(this.arr))
          .subscribe((response) => {
            this.selection.clear();
            this.listItems = [];
            this.arr = [];
            this.selection.clear();
            if (this.roleuser == "User") {
              this.getDriverListUser(15, "");
            } else {
              this.getDriverList(15, "");
            }
          });
      } else {
        this.arr = [];
        this.listItems = [];
        this.selection.clear();
      }
    });
  }

  getItem() {}

  exportExcel(e, e2) {
    Swal.fire({
      title: "Souhaitez-vous exporter la table ?",
      showCancelButton: true,
      confirmButtonText: "Exporter Fichier !",
      cancelButtonText: "Annuler",
      confirmButtonColor: "#262756",
      cancelButtonColor: "#e05a61",
    }).then((result) => {
      if (result.value) {
        Swal.fire("Le fichier est exporté .");
        //console.log(e);
        e.exportTable(e2, {
          fileName: "STG_DRIVE_conducteurs_date_" + new Date().toLocaleString(),
          sheet: "STG DRIVE conducteurs",
          Props: { Author: "STG_DRIVE" },
        });
        /* var filename ='incoming message'

        const workSheet = XLSX.utils.json_to_sheet(this.dataSource.data, {header:["A","B","C","D","E","F",""], skipHeader:false});
        const workBook: XLSX.WorkBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workBook, workSheet, 'SheetName');
        XLSX.writeFile(workBook, filename+new Date()+'.xlsx'); */

        // For more information about handling dismissals please visit
        // https://sweetalert2.github.io/#handling-dismissals
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire("Annuler", "Fichier non exporté !!");
      }
    });
  }

  triggerFalseClick() {
    Swal.fire({
      title: "Êtes-vous sûr?",
      showCancelButton: true,
      confirmButtonColor: "#262756",
      cancelButtonColor: "#e05a61",
      confirmButtonText: "Oui, supprimez!",
      cancelButtonText: "Annuler",
    }).then((result) => {
      if (result.value) {
        Swal.fire("Conducteur Supprimé avec succès!");
        let el: HTMLElement = this.myDiv.nativeElement;
        el.click();

        // For more information about handling dismissals please visit
        // https://sweetalert2.github.io/#handling-dismissals
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire("Annulé");
      }
    });

    location.reload();
  }

  openDialogUpdate(operation, id: any, reseller_id: any, row) {
    if (this.roleuser == "User") {
      let dialogRef = this.dialog.open(EditDriveruser, {
        data: {
          animal: "panda",
        },
        disableClose: true,
        autoFocus: false,
        panelClass: "my-custom-dialog-class",
      });
      if (operation == "oneItem") {
        this.selection.clear();
        // this.listItems = []
        this.arr = [];
        // this.listItems.push({
        //   id: id,
        //   reseller_id: reseller_id
        // })
      }
      // console.log("listItems listItems");
      // console.log(this.listItems);
      // console.log("row row row");
      // console.log(row);

      // this.traslateService.urlPathQuote.next(this.listItems);
      this.traslateService.urlPathQuote.next([row]);
      dialogRef.afterClosed().subscribe((result) => {
        let index = this.repos.findIndex((driver) => driver?.id === result?.id);
        if (this.repos[index] != undefined) {
          Object.assign(this.repos[index], result?.form);
        }
        this.selection.clear();
      });
    } else {
      let dialogRef = this.dialog.open(EditDriver, {
        data: {
          animal: "panda",
        },
        disableClose: true,
        autoFocus: false,
        panelClass: "my-custom-dialog-class",
      });

      if (operation == "oneItem") {
        this.selection.clear();
        // this.listItems = []
        this.arr = [];
        // this.listItems.push({
        //   id: id,
        //   reseller_id: reseller_id
        // })
      }
      // console.log("listItems listItems");
      // console.log(this.listItems);
      // console.log("row row row");
      // console.log(row);

      // this.traslateService.urlPathQuote.next(this.listItems);
      this.traslateService.urlPathQuote.next([row]);
      dialogRef.afterClosed().subscribe((result) => {
        let index = this?.repos.findIndex(
          (driver) => driver?.id === result?.id
        );
        if (this.repos[index] != undefined) {
          Object.assign(this.repos[index], result?.form);
        }
        this.selection.clear();
      });
    }
  }

  getDataSource() {
    return this.dataSource;
  }

  openDialogFileUpload2() {
    if (this.roleuser == "User") {
      this.dialog.open(AddDriveruser, {
        data: {
          animal: "panda",
        },
        autoFocus: false,
        panelClass: "my-custom-dialog-class",
      });
      this.traslateService.urlPathQuote.next(this.listItems);
    } else {
      this.dialog.open(AddDriver, {
        data: {
          animal: "panda",
        },
        autoFocus: false,
        panelClass: "my-custom-dialog-class",
      });
      this.traslateService.urlPathQuote.next(this.listItems);
    }
  }
}

interface Food {
  value: string;
  viewValue: string;
}

interface Car {
  value: string;
  viewValue: string;
}

@Component({
  // tslint:disable-next-line:component-selector
  selector: "EditDriver",
  templateUrl: "EditDriver.html",
  styleUrls: ["./driver.component.scss"],
})
// tslint:disable-next-line:component-class-suffix
export class EditDriver {
  selectedValue: string;
  selectedCar: string;
  selectedGroupe: string;

  groupe: any[] = [];
  name: string;
  url: any;
  entry: any;
  archived: any;
  default_branch: any;
  description: any;
  compagnie: any;
  revendeur: any;
  hiddenBtn: any;
  revendeurCompany: any;
  revendeurCompanyId: any = null;
  reseller_id: any;
  revendeurs: any;
  selectedRevendeur: any;
  company: any;
  dallas: any;
  gsm_number: any;
  date_birth: any;
  first_name: any;
  last_name: any;
  date_driving_license: any;
  idCompany: any;
  civility: any;
  driverPutSpinner: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<EditDriver>,
    public traslateService: TraslateService,
    private formBuilder: FormBuilder,
    private http: HttpClient,
    private spinnerdriver: NgxSpinnerService
  ) {
    this.traslateService.obs2.subscribe((response) => {
      this.traslateService.getRevendeur();
      //console.log(response)
      this.revendeur = response;

      this.click2();
    });
  }

  ngOnInit(): void {
    this.traslateService.currentdataQuote.subscribe((data) => {
      this.url = data;
      console.log("HANAAAAA", this.url);
    });

    console.log(this.url);

    //console.log(this.url)

    for (let entry of this.url) {
      //console.log(entry.id); // 1, "string", false
      this.entry = entry.id;
      this.name = entry.name;
      this.company = entry.company;
      this.dallas = entry.dallas;
      this.gsm_number = entry.gsm_number;
      this.date_birth = entry.date_birth;
      this.first_name = entry.first_name;
      this.last_name = entry.last_name;
      this.date_driving_license = entry.date_driving_license;
      this.idCompany = entry.company_id;
      this.companyname = entry.company;
      this.reseller_id = entry.reseller_id;
      this.civility = entry.civility;
    }
    console.log("entryy", this.entry.name, this.entry.dallas);
    this.getIdrevendeur(this.reseller_id);

    //console.log(this.compagnie)
  }

  users: any[] = [];

  filteredData;

  applyFilter(evt: string) {
    console.log("evnt ");
    console.log(evt);

    evt = evt + "";
    if (!evt) this.filteredData = this.revendeurCompanyId;
    else {
      /** uses both id and text fields for extensive filtering (case insensitive) . can be tailored for custom needs */
      this.filteredData = this.revendeurCompanyId?.filter(
        (item) =>
          item.id + "" === evt ||
          item.name.toLocaleLowerCase().indexOf(evt.toLocaleLowerCase()) >= 0
      );
    }
  }

  valueMapper = (key) => {
    let selection = this.revendeurCompanyId?.find((e) => {
      return e.id == key;
    });
    if (selection) {
      return selection.name;
    }
  };

  click2() {
    //console.log(this.revendeur?.resellers[this.reseller_id])
    this.revendeurs = this.revendeur?.resellers;
    this.selectedRevendeur = this.revendeur?.resellers[this.reseller_id]?.name;
  }

  addUser() {
    this.name = (<HTMLInputElement>document.getElementById("name")).value;

    this.users.push(this.name); //push empty object of type user
    this.groupe = this.users;
    //console.log(this.groupe)
  }

  listUser() {
    this.groupe = this.users;
    //console.log(this.groupe)
  }

  // tslint:disable-next-line:member-ordering
  registerForm: FormGroup = this.formBuilder.group({
    // tslint:disable-next-line:quotemark
    reseller_id: [, { validators: [Validators.required], updateOn: "change" }],
    company_id: [, { validators: [Validators.required], updateOn: "change" }],
    driver: [],
    gsm_number: [],
    gsm_numbere: [],
    date_birth: [],
    date_driving_license: [],
    dallas: [, { validators: [Validators.required], updateOn: "change" }],
    first_name: [],
    last_name: [, { validators: [Validators.required], updateOn: "change" }],
    civility: [],
  });

  companyname = "";

  matcher = new MyErrorStateMatcher();

  submitFormUpdate() {
    //console.log('LKLK'+this.registerForm);
    Object.values(this.registerForm).forEach((val) => {
      //console.log(val);
    });

    //location.reload()
  }

  submitForm() {
    //console.log('LKLK'+this.registerForm);

    Object.values(this.registerForm).forEach((val) => {
      //console.log(val);
    });

    this.driverPutSpinner = true;
    this.spinnerdriver.show();

    // console.log("this.entryyy ");
    // console.log(this.entry);
    // console.log("this.registerForm.value ");
    // console.log(this.registerForm.value);

    this.http
      .put(
        environment.apiUrl + "/drivers/" + this.entry,
        this.registerForm.value
      )
      .subscribe((data) => {
        //console.log(data)
        var resp: any = data;
        if (resp.status == 200) {
          this.spinnerdriver.hide();
          this.driverPutSpinner = false;
          Swal.fire({
            position: "center",
            title: "Modification enregistré avec succès!",
            showConfirmButton: false,
            timer: 1000,
          });

          // location.reload()
          // console.log("drivers repos" , this.repos)

          this.dialogRef.close({
            id: this.entry,
            form: this.registerForm.value,
          });
        } else {
          this.spinnerdriver.hide();
          this.driverPutSpinner = false;
          Swal.fire({
            text: resp.message.join("<br>"),
          });
        }
      });
    //location.reload()
  }

  getIdrevendeur(e) {
    const headerDict = {
      "Content-Type": "application/json",
      Accept: "application/json",
      "Access-Control-Allow-Headers": "Content-Type",
    };

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };
    this.driverPutSpinner = true;
    this.spinnerdriver.show();

    this.http
      .get(
        environment.apiUrl + "/resellers/" + e + "/companies/all",
        requestOptions
      )
      .subscribe((response) => {
        // work with posts
        //console.log(response)
        this.revendeurCompany = response;
        this.revendeurCompanyId = this.revendeurCompany?.companies;
        console.log("revendeurCompanyId", this.revendeurCompanyId);
        this.spinnerdriver.hide();
        this.driverPutSpinner = false;
      });

    //console.log(e)
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}

@Component({
  // tslint:disable-next-line:component-selector
  selector: "EditDriveruser",
  templateUrl: "EditDriveruser.html",
  styleUrls: ["./driver.component.scss"],
})
// tslint:disable-next-line:component-class-suffix
export class EditDriveruser {
  selectedValue: string;
  selectedCar: string;
  selectedGroupe: string;

  groupe: any[] = [];
  name: string;
  url: any;
  entry: any;
  archived: any;
  default_branch: any;
  description: any;
  compagnie: any;
  revendeur: any;
  hiddenBtn: any;
  revendeurCompany: any;
  revendeurCompanyId: any = null;
  reseller_id: any;
  revendeurs: any;
  selectedRevendeur: any;
  company: any;
  dallas: any;
  gsm_number: any;
  date_birth: any;
  first_name: any;
  last_name: any;
  date_driving_license: any;
  idCompany: any;
  civility: any;
  driverPutSpinner: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<EditDriver>,
    public traslateService: TraslateService,
    private formBuilder: FormBuilder,
    private http: HttpClient,
    private spinnerdriver: NgxSpinnerService
  ) {
    this.traslateService.obs2.subscribe((response) => {
      this.traslateService.getRevendeur();
      //console.log(response)
      this.revendeur = response;

      this.click2();
    });
  }

  ngOnInit(): void {
    this.traslateService.currentdataQuote.subscribe((data) => {
      this.url = data;
    });

    //console.log(this.url)

    for (let entry of this.url) {
      //console.log(entry.id); // 1, "string", false
      this.entry = entry.id;
      this.name = entry.name;
      this.company = entry.company;
      this.dallas = entry.dallas;
      this.gsm_number = entry.gsm_number;
      this.date_birth = entry.date_birth;
      this.first_name = entry.first_name;
      this.last_name = entry.last_name;
      this.date_driving_license = entry.date_driving_license;
      this.idCompany = entry.company_id;
      this.reseller_id = entry.reseller_id;
      this.civility = entry.civility;
    }
    this.getIdrevendeur(this.reseller_id);

    //console.log(this.compagnie)
  }

  users: any[] = [];

  click2() {
    //console.log(this.revendeur?.resellers[this.reseller_id])
    this.revendeurs = this.revendeur?.resellers;
    this.selectedRevendeur = this.revendeur?.resellers[this.reseller_id]?.name;
  }

  addUser() {
    this.name = (<HTMLInputElement>document.getElementById("name")).value;

    this.users.push(this.name); //push empty object of type user
    this.groupe = this.users;
    //console.log(this.groupe)
  }

  listUser() {
    this.groupe = this.users;
    //console.log(this.groupe)
  }

  // tslint:disable-next-line:member-ordering
  registerForm: FormGroup = this.formBuilder.group({
    // tslint:disable-next-line:quotemark
    reseller_id: [, { validators: [Validators.required], updateOn: "change" }],
    company_id: [, { validators: [Validators.required], updateOn: "change" }],
    driver: [],
    gsm_number: [],
    date_birth: [],
    date_driving_license: [],
    dallas: [, { validators: [Validators.required], updateOn: "change" }],
    first_name: [],
    last_name: [, { validators: [Validators.required], updateOn: "change" }],
    civility: [],
  });

  matcher = new MyErrorStateMatcher();

  submitFormUpdate() {
    //console.log('LKLK'+this.registerForm);
    Object.values(this.registerForm).forEach((val) => {
      //console.log(val);
    });

    //location.reload()
  }

  submitForm() {
    //console.log('LKLK'+this.registerForm);

    Object.values(this.registerForm).forEach((val) => {
      //console.log(val);
    });

    this.driverPutSpinner = true;
    this.spinnerdriver.show();

    this.http
      .put(
        environment.apiUrl + "/drivers/" + this.entry,
        this.registerForm.value
      )
      .subscribe((data) => {
        //console.log(data)
        var resp: any = data;
        if (resp.status == 200) {
          this.spinnerdriver.hide();
          this.driverPutSpinner = false;
          Swal.fire({
            position: "center",
            title: "Modification enregistré avec succès!",
            showConfirmButton: false,
            timer: 1000,
          });

          // location.reload()
          // console.log("drivers repos" , this.repos)

          this.dialogRef.close({
            id: this.entry,
            form: this.registerForm.value,
          });
        } else {
          this.spinnerdriver.hide();
          this.driverPutSpinner = false;
          Swal.fire({
            text: resp.message.join("<br>"),
          });
        }
      });
    //location.reload()
  }

  getIdrevendeur(e) {
    const headerDict = {
      "Content-Type": "application/json",
      Accept: "application/json",
      "Access-Control-Allow-Headers": "Content-Type",
    };

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };
    this.driverPutSpinner = true;
    this.spinnerdriver.show();

    this.http
      .get(
        environment.apiUrl + "/resellers/" + e + "/companies/all",
        requestOptions
      )
      .subscribe((response) => {
        // work with posts
        //console.log(response)
        this.revendeurCompany = response;
        this.revendeurCompanyId = this.revendeurCompany?.companies;
        //console.log(this.revendeurCompanyId )
        this.spinnerdriver.hide();
        this.driverPutSpinner = false;
      });

    //console.log(e)
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}

@Component({
  // tslint:disable-next-line:component-selector
  selector: "AddDriver",
  templateUrl: "AddDriver.html",
  styleUrls: ["./driver.component.scss"],
})
// tslint:disable-next-line:component-class-suffix
export class AddDriver {
  selectedValue: string;
  selectedCar: string;
  selectedGroupe: string;

  groupe: any[] = [];
  name: string;
  ff: string;
  revendeurCompany: any;
  revendeurCompanyId: any = null;
  revendeur: any;
  url: any;
  entry: any;
  device_id: any;
  idCompany: any;
  reseller_id: any;
  revendeurs: any;
  selectedRevendeur: any;
  driverPostSpinner: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<AddDriver>,
    public traslateService: TraslateService,
    private formBuilder: FormBuilder,
    private http: HttpClient,
    private spinnerActiveDriver: NgxSpinnerService
  ) {
    this.traslateService.obs2.subscribe((response) => {
      this.traslateService.getRevendeur();
      //console.log(response)
      this.revendeur = response;
      this.click2();
    });
  }

  ngOnInit(): void {
    this.traslateService.currentdataQuote.subscribe((data) => {
      this.url = data;
    });

    //console.log(this.url)

    for (let entry of this.url) {
      //console.log(entry.id); // 1, "string", false
      this.entry = entry.id;

      this.device_id = entry.device_id;

      this.idCompany = entry.company_id;
      this.reseller_id = entry.reseller_id;

      //console.log('jkljkljlk'+this.entry )
    }

    // this.ff = (<HTMLInputElement>document.getElementById('checkbox')).value
  }

  click2() {
    this.revendeurs = this.revendeur?.resellers;
    this.selectedRevendeur = this.revendeur?.resellers[this.reseller_id]?.name;
  }

  // tslint:disable-next-line:member-ordering
  registerForm: FormGroup = this.formBuilder.group({
    // tslint:disable-next-line:quotemark
    reseller_id: [, { validators: [Validators.required], updateOn: "change" }],
    company_id: [, { validators: [Validators.required], updateOn: "change" }],
    driver: [],
    gsm_number: [],
    date_birth: [],
    date_driving_license: [],
    dallas: [, { validators: [Validators.required], updateOn: "change" }],
    first_name: [],
    last_name: [, { validators: [Validators.required], updateOn: "change" }],
    civility: [],
  });
  searchbycompnid: any;
  filteredData;

  applyFilter(evt: string) {
    console.log("evnt ");
    console.log(evt);

    evt = evt + "";
    if (!evt) this.filteredData = this.revendeurCompanyId;
    else {
      /** uses both id and text fields for extensive filtering (case insensitive) . can be tailored for custom needs */
      this.filteredData = this.revendeurCompanyId?.filter(
        (item) =>
          item.id + "" === evt ||
          item.name.toLocaleLowerCase().indexOf(evt.toLocaleLowerCase()) >= 0
      );
    }
  }

  valueMapper = (key) => {
    let selection = this.revendeurCompanyId?.find((e) => {
      return e.id == key;
    });
    if (selection) {
      return selection.name;
    }
  };

  submitForm() {
    //console.log('LKLK'+this.registerForm);
    Object.values(this.registerForm).forEach((val) => {
      //console.log(val);
    });

    this.driverPostSpinner = true;
    this.spinnerActiveDriver.show();
    this.http
      .post(environment.apiUrl + "/drivers", this.registerForm.value)
      .subscribe((data) => {
        //console.log(data)
        var resp: any = data;
        if (resp.status == 200) {
          this.spinnerActiveDriver.hide();
          this.driverPostSpinner = false;

          Swal.fire({
            position: "center",
            title: "Modification enregistré avec succès!",
            showConfirmButton: false,
            timer: 1000,
          });

          location.reload();
        } else {
          this.spinnerActiveDriver.hide();
          this.driverPostSpinner = false;

          Swal.fire({
            text: resp.message.join("<br>"),
          });
        }
      });
    //location.reload()
  }

  matcher = new MyErrorStateMatcher();

  users: any[] = [];

  getIdrevendeur(e) {
    const headerDict = {
      "Content-Type": "application/json",
      Accept: "application/json",
      "Access-Control-Allow-Headers": "Content-Type",
    };

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };
    this.driverPostSpinner = true;
    this.spinnerActiveDriver.show();
    this.http
      .get(
        environment.apiUrl + "/resellers/" + e + "/companies/all",
        requestOptions
      )

      .subscribe((response) => {
        // work with posts
        //console.log(response)
        this.revendeurCompany = response;
        this.revendeurCompanyId = this.revendeurCompany?.companies;
        this.filteredData = this.revendeurCompanyId;
        //console.log(this.revendeurCompanyId )
        this.spinnerActiveDriver.hide();
        this.driverPostSpinner = false;
      });

    //console.log(e)
  }

  addUser() {
    this.name = (<HTMLInputElement>document.getElementById("name")).value;

    this.users.push(this.name); //push empty object of type user
    this.groupe = this.users;
    //console.log(this.groupe)
  }

  listUser() {
    this.groupe = this.users;
    //console.log(this.groupe)
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}

@Component({
  // tslint:disable-next-line:component-selector
  selector: "AddDriveruser",
  templateUrl: "AddDriveruser.html",
  styleUrls: ["./driver.component.scss"],
})
// tslint:disable-next-line:component-class-suffix
export class AddDriveruser {
  selectedValue: string;
  selectedCar: string;
  selectedGroupe: string;

  groupe: any[] = [];
  name: string;
  ff: string;
  revendeurCompany: any;
  revendeurCompanyId: any = null;
  revendeur: any;
  url: any;
  entry: any;
  device_id: any;
  idCompany: any;
  reseller_id: any;
  revendeurs: any;
  selectedRevendeur: any;
  driverPostSpinner: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<AddDriver>,
    public traslateService: TraslateService,
    private formBuilder: FormBuilder,
    private http: HttpClient,
    private spinnerActiveDriver: NgxSpinnerService
  ) {
    this.traslateService.obs2.subscribe((response) => {
      this.traslateService.getRevendeur();
      //console.log(response)
      this.revendeur = response;
      this.click2();
    });
  }

  ngOnInit(): void {
    this.traslateService.currentdataQuote.subscribe((data) => {
      this.url = data;
    });

    //console.log(this.url)

    for (let entry of this.url) {
      //console.log(entry.id); // 1, "string", false
      this.entry = entry.id;

      this.device_id = entry.device_id;

      this.idCompany = entry.company_id;
      this.reseller_id = entry.reseller_id;

      //console.log('jkljkljlk'+this.entry )
    }

    // this.ff = (<HTMLInputElement>document.getElementById('checkbox')).value
  }

  click2() {
    this.revendeurs = this.revendeur?.resellers;
    this.selectedRevendeur = this.revendeur?.resellers[this.reseller_id]?.name;
  }

  // tslint:disable-next-line:member-ordering
  registerForm: FormGroup = this.formBuilder.group({
    // tslint:disable-next-line:quotemark
    // reseller_id: [, { validators: [Validators.required], updateOn: "change" }],
    // company_id: [, { validators: [Validators.required], updateOn: "change" }],
    driver: [],
    gsm_number: [],
    date_birth: [],
    date_driving_license: [],
    dallas: [, { validators: [Validators.required], updateOn: "change" }],
    first_name: [],
    last_name: [, { validators: [Validators.required], updateOn: "change" }],
    civility: [],
  });

  submitForm() {
    //console.log('LKLK'+this.registerForm);
    Object.values(this.registerForm).forEach((val) => {
      //console.log(val);
    });

    this.driverPostSpinner = true;
    this.spinnerActiveDriver.show();
    this.http
      .post(environment.apiUrl + "/drivers", this.registerForm.value)
      .subscribe((data) => {
        //console.log(data)
        var resp: any = data;
        if (resp.status == 200) {
          this.spinnerActiveDriver.hide();
          this.driverPostSpinner = false;

          Swal.fire({
            position: "center",
            title: "Modification enregistré avec succès!",
            showConfirmButton: false,
            timer: 1000,
          });

          location.reload();
        } else {
          this.spinnerActiveDriver.hide();
          this.driverPostSpinner = false;

          Swal.fire({
            text: resp.message.join("<br>"),
          });
        }
      });
    //location.reload()
  }

  matcher = new MyErrorStateMatcher();

  users: any[] = [];

  getIdrevendeur(e) {
    const headerDict = {
      "Content-Type": "application/json",
      Accept: "application/json",
      "Access-Control-Allow-Headers": "Content-Type",
    };

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };
    this.driverPostSpinner = true;
    this.spinnerActiveDriver.show();
    this.http
      .get(
        environment.apiUrl + "/resellers/" + e + "/companies",
        requestOptions
      )

      .subscribe((response) => {
        // work with posts
        //console.log(response)
        this.revendeurCompany = response;
        this.revendeurCompanyId = this.revendeurCompany?.companies;
        //console.log(this.revendeurCompanyId )
        this.spinnerActiveDriver.hide();
        this.driverPostSpinner = false;
      });

    //console.log(e)
  }

  addUser() {
    this.name = (<HTMLInputElement>document.getElementById("name")).value;

    this.users.push(this.name); //push empty object of type user
    this.groupe = this.users;
    //console.log(this.groupe)
  }

  listUser() {
    this.groupe = this.users;
    //console.log(this.groupe)
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
